<script setup lang="ts">
const { t } = useI18n()

useHead({
  titleTemplate: () => t("seo.layouts./contacts.title") || t("contacts.title"),
  meta: [
    { name: "description", content: () => t("seo.layouts./contacts.description") || t("seo.description") },
    { property: "og:title", content: () => t("seo.layouts./contacts.title") || t("contacts.title") },
    { property: "og:description", content: () => t("seo.layouts./contacts.description") || t("seo.description") },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary_large_image" }
  ]
})
</script>

<template>
  <div>
    <div class="page-title">{{ $t('contacts.title') }}</div>

    <div class="page-section contacts-description small-section">
      <div class="container">
        <div class="mail-bg-img"></div>
        <div class="section-content">
          <div class="text-content">
            <p>
              {{ $t('contacts.subTitleElements[0]') }}
              <span class="highlight-blue">{{ $t('contacts.subTitleElements[1]') }}</span>
              {{ $t('contacts.subTitleElements[2]') }}
              <span class="highlight-blue">{{ $t('contacts.subTitleElements[3]') }}</span>
              {{ $t('contacts.subTitleElements[4]') }}
            </p>
            <p>
              {{ $t('contacts.subTitleElements[5]') }}
              <span class="highlight-blue">{{ $t('contacts.subTitleElements[6]') }}</span>
              {{ $t('contacts.subTitleElements[7]') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <ContactForm/>
  </div>
</template>
